// src/CategoryBar.jsx
export const CATEGORIES = [
  "AI-tools ",
  "Developer Tools",       // ✅ NEW CATEGORY
  "Design-tools",
  "Productivity-tools",
  "writing-tools",
  "Entertainment",
  "utility-tools",
];

export default function CategoryBar({ activeCategory, onCategoryChange }) {
  return (
    <section className="w-full mt-6 mb-4">
      <div className="max-w-5xl mx-auto px-4">

        {/* Dropdown (visible always) */}
        <div className="flex justify-center mb-4">
          <label className="sr-only" htmlFor="category-select">
            Select category
          </label>
          <select
            id="category-select"
            value={activeCategory}
            onChange={(e) => onCategoryChange(e.target.value)}
            className="w-full max-w-sm px-4 py-2 rounded-full bg-neutral-100 dark:bg-neutral-900 border border-neutral-300 dark:border-neutral-700 text-neutral-700 dark:text-neutral-300"
          >
            {CATEGORIES.map((cat) => (
              <option key={cat} value={cat} className="text-sm">
                {cat}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-wrap gap-3 justify-center">
          {CATEGORIES.map((cat) => {
            const isActive = activeCategory === cat;

            return (
              <button
                key={cat}
                onClick={() => onCategoryChange(cat)}
                className={`
                  px-4 py-2 rounded-full text-sm font-medium
                  transition shadow-sm
                  ${
                    isActive
                      ? "bg-gradient-to-r from-lime-400 to-emerald-500 text-black shadow"
                      : "bg-neutral-200 dark:bg-neutral-800 text-neutral-700 dark:text-neutral-300 hover:bg-neutral-300 dark:hover:bg-neutral-700"
                  }
                `}
              >
                {cat}
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
